const moment = require('moment')

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const phoneRegex = /^\d{10}$/

const coerceToArray = e => Array.isArray(e) ? e : [e]

const filterAccess = (a, u) => a.filter(b => (b.exact || Array.isArray(b.access)) ? coerceToArray(b.access).indexOf(u.roleIndex) != -1 : u.roleIndex <= (b.access || 99999))

const getTimeElapsed = dateString => {
    const now = moment()
    const past = moment(dateString)
    const duration = moment.duration(now.diff(past))

    if (duration.asSeconds() < 60) {
        return duration.asSeconds() < 2 ? 'a few seconds ago' : `${Math.floor(duration.asSeconds())} seconds ago`
    } else if (duration.asMinutes() < 60) {
        return duration.asMinutes() < 2 ? 'a few minutes ago' : `${Math.floor(duration.asMinutes())} minute${Math.floor(duration.asMinutes()) === 1 ? '' : 's'} ago`
    } else if (duration.asHours() < 24) {
        return `${Math.floor(duration.asHours())} hour${Math.floor(duration.asHours()) === 1 ? '' : 's'} ago`
    } else if (duration.asDays() < 7) {
        return `${Math.floor(duration.asDays())} day${Math.floor(duration.asDays()) === 1 ? '' : 's'} ago`
    } else if (duration.asWeeks() < 4) {
        return `${Math.floor(duration.asWeeks())} week${Math.floor(duration.asWeeks()) === 1 ? '' : 's'} ago`
    } else if (duration.asMonths() < 12) {
        return `${Math.floor(duration.asMonths())} month${Math.floor(duration.asMonths()) === 1 ? '' : 's'} ago`
    } else {
        return `${Math.floor(duration.asYears())} year${Math.floor(duration.asYears()) === 1 ? '' : 's'} ago`
    }
}

const _ = {
    emailRegex,
    phoneRegex,
    getTimeElapsed,
    coerceToArray,
    filterAccess
}

export default _